@if (_loading) {
  <div class="flex flex-col space-y-8 items-center">
    @if (show) {
      <img class="bounce" src="assets/emblem.svg" [style.width.px]="width" />
    }
    <div class="text-xl font-bold text-gray-700 text-center">{{ _text }}</div>
  </div>
}
